import { createAction, props } from '@ngrx/store';
import { TokenModel } from '../../../model/token.model';
import { UserInfo } from '../../../model/user.model';

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ token: TokenModel; user: UserInfo }>(),
);

export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: unknown; errorMessage: string }>(),
);

export const checkAuth = createAction('[Auth] Check Auth Status');
export const checkAuthSuccess = createAction(
  '[Auth API] Check Auth Success',
  props<{ token: TokenModel }>(),
);
export const checkAuthFailure = createAction('[Auth API] Check Auth Failure');

export const tokenRefreshed = createAction(
  '[Auth API] Token Refreshed',
  props<{ token: TokenModel }>(),
);

export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth API] Logout Success');
export const logoutFailure = createAction('[Auth API] Logout Failure', props<{ error: any }>());

// Force logout without API call - used when backend is unreachable or returns 401
// This ensures user is always logged out locally even if server is down
export const forceLogout = createAction('[Auth] Force Logout', props<{ reason?: string }>());
